/* eslint-disable react/no-unescaped-entities */
import LegalLayout from "./LegalLayout";
import Seo, { breadcrumbTrail } from "../components/dmb/Seo";

export default function Cookies() {
    return (
        <LegalLayout
            testid="cookies"
            kicker="Informations légales"
            title="Politique cookies"
            lastUpdate="16 octobre 2026"
        >
            <Seo
                title="Politique cookies | DMB Partners"
                description="Le site DMB Partners n'utilise aucun cookie de mesure d'audience ni cookie publicitaire : uniquement les stockages strictement nécessaires à son fonctionnement."
                path="/cookies"
                jsonLd={breadcrumbTrail([
                    { name: "Accueil", path: "/" },
                    { name: "Politique cookies", path: "/cookies" },
                ])}
            />
            <p>
                Le Site n'utilise que des cookies et stockages strictement
                nécessaires à son fonctionnement (notamment le maintien de la
                connexion à l'espace d'administration). Conformément aux
                recommandations de la CNIL, ils ne nécessitent pas votre accord.
                Aucun cookie de mesure d'audience ni cookie publicitaire n'est
                déposé sur le Site.
            </p>

            <h2>Cookies utilisés sur le Site</h2>
            <table>
                <thead>
                    <tr>
                        <th>Catégorie</th>
                        <th>Finalité</th>
                        <th>Durée</th>
                        <th>Accord requis</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Strictement nécessaires</td>
                        <td>Fonctionnement du Site</td>
                        <td>Durée de la session</td>
                        <td>Non</td>
                    </tr>
                </tbody>
            </table>
        </LegalLayout>
    );
}
